const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'stretch',
  },

  background: {
    position: 'absolute',
    top: 200,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    zIndex: -1,
  },

  lhc: {
    flex: '1 1',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },

  rhc: {
    boxShadow: 'inset 1px 0 0 #f6f7fa',
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '75px',
  },
});

export default styles;
